import axios from "axios";
import qs from "qs";

const api = "/creditapi";

/**
 * 搜索文章
 * @param title         标题
 * @param publishFlag   状态
 * @param pageNum       页数
 * @param pageSize      每页显示数量
 * @returns {AxiosPromise<any>}
 */
export function search({
                           name,
                           auditingFlag,
                           pageNum,
                           pageSize
                       }) {
    return axios.get(api + "/info/get", {
        params: {
            name,
            auditingFlag,
            pageNum,
            pageSize
        }
    })
}




/**
 * 保存文章
 * @param id            文章主键
 * @param title         文章标题
 * @param author        文章作者
 * @param content       文章内容
 * @param publishFlag   发布标志位
 * @returns {AxiosPromise<any>}
 */
export function saveArticle({
                                title, author,  source,  publishDate,
                                accessoryIds,  accessoryNames,
                                content, auditingFlag, topicId
                            }) {
    return axios.post(api + "/info/add", qs.stringify({
        title, author,  source,  publishDate,
         accessoryIds,  accessoryNames,
        content, auditingFlag, topicId
    }))
}

/**
 * 查找单片文章内容
 * @param id 文章主键
 * @returns {AxiosPromise<any>}
 */
export function findById(id) {
    return axios.get(api + "/info/findById?infoId=" + id)
}

/**
 * 删除文章
 * @param id 文章主键
 * @returns {AxiosPromise<any>}
 */
export function deleteArticle(infoId) {
    return axios.get(api + "/info/delete", {
        params: {
            infoId
        }
    })
}

export function updateArticle({infoId,
                                title, author,  source,  publishDate,
                                accessoryIds,  accessoryNames,
                                content, auditingFlag, topicId
                            }) {
    return axios.post(api + "/info/update", qs.stringify({
        infoId,title, author,  source,  publishDate,
        accessoryIds,  accessoryNames,
        content, auditingFlag, topicId
    }))
}


export function getSelectAjax() {
    return axios.post(api + "/info/getSelect")
}
